import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Provinces } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "../../assets/ts/components/_CookieComponent";

@Module
export default class ProvinceModule extends VuexModule {
  @Action
  [Provinces.findProvinceByUser]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/province/findByUser", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Provinces.findProvinceByUserAll]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/province/findByUserAll", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Provinces.findProvinceByUserVer2]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/province/findByUserVer2", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Provinces.findProvinceByUserVerify]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/province/findByUserVerify", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Provinces.findProvinceByAccount]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/province/findByAccount", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
}
